import {
  GetApplicantPaymentsArgs
} from '@/schemas/payments.schema'
import { useQuery } from '@tanstack/react-query'
import { getPayments } from '../requests'

export const paymentsKeys = {
  all: ['paymentDetail'] as const,
  detail: (args: GetApplicantPaymentsArgs) => {
    return [...paymentsKeys.all, args] as const
  }
}
/**
 * Custom hook for fetching payment details using TanStack Query
 * @param args - The payment ID and program ID
 * @returns Query result with payment details data, loading state, and error
 */
export const useGetPayments = (args: GetApplicantPaymentsArgs) => {
  return useQuery({
    queryKey: paymentsKeys.detail(args),
    queryFn: () => getPayments(args),
    refetchOnMount: "always"
  })
}
